import { CSSProperties } from 'react';
import {
  mediaQuery,
  minBreakpoints,
  pxToRem,
  responsiveFontSize,
  theme,
} from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import { nothsTheme } from 'src/styles/noths.theme';

export interface CSSVarTitle extends CSSProperties {
  '--topMargin'?: string;
  '--uppercase'?: string;
}

export interface CSSVarBorderLine extends CSSProperties {
  '--gutter'?: string;
}

const { fonts, text, spacing } = theme;
const { font: nothsFont, color: nothsColor, space: nothsSpace } = nothsTheme;

export const Container = css`
  max-width: 960px;
  padding: 0 15px;
  margin: 0 auto;
  min-height: 300px;

  &[data-no-padding='true'] {
    padding: 0;
  }

  &[data-wide='true'] {
    max-width: 1070px;
  }
`;

export const ContainerFluid = css`
  width: 100vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
`;

export const Section = css`
  padding: 0 0 ${pxToRem(spacing.xl)} 0;

  &[data-double-padding='true'] {
    ${mediaQuery(
      { min: minBreakpoints.MEDIUM },
      css`
        padding-bottom: 65px;
      `,
    )};
  }

  &:last-of-type {
    padding-bottom: 0;
  }

  &[data-is-hidden='true'] {
    display: none;
  }
`;

export const BorderLine = css`
  display: block;
  height: ${pxToRem(spacing.xl)};
  margin: 0 var(--gutter, 0);
  background: ${nothsColor.background};

  ${mediaQuery(
    { min: minBreakpoints.MEDIUM },
    css`
      display: none;
    `,
  )};
`;

export const Heading = css`
  font-family: ${fonts.PRIMARY_SEMIBOLD.family};
  font-size: ${nothsFont.size.L};
  line-height: 1.25;
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
  letter-spacing: 1px;
  text-align: center;
  text-transform: uppercase;
  color: ${nothsColor.primaryDark};
  margin: 0;
  padding-top: ${nothsSpace.XXL};
  padding-bottom: ${nothsSpace.XXL};
  -webkit-font-smoothing: antialiased;

  &[data-with-sub-heading='true'] {
    padding-bottom: 0;
  }

  &[data-custom-heading='true'] {
    padding-top: ${pxToRem(spacing.xxl)};
    padding-bottom: ${pxToRem(spacing.xl)};
  }
`;

export const Title = css`
  font-family: ${fonts.PRIMARY_REGULAR.family};
  ${responsiveFontSize(text.md)};
  font-weight: 400;
  text-align: center;
  margin-bottom: ${pxToRem(spacing.xs)};
  margin-top: var(--topMargin);
  -webkit-font-smoothing: antialiased;
  color: ${nothsColor.primaryDarker};

  &[data-negative-colours='true'] {
    color: ${nothsColor.white};
  }
`;

export const SubTitle = css`
  font-family: ${nothsFont.family.tertiary};
  font-size: ${nothsFont.size.S};
  line-height: 1;
  font-weight: 400;
  font-style: italic;
  text-align: center;
  color: ${nothsColor.primary};
  -webkit-font-smoothing: antialiased;
  margin: 0;
  padding: 0;

  &[data-negative-colours='true'] {
    color: ${nothsColor.white};
  }
`;
